import type { ExerciseCompletionEntry } from '@/api/treatmentPlans/treatmentPlansApi.types';
import { formatIsoDateToDayAndMonth } from '@/utils/dateFormatting';

interface RecentExerciseSessionsProps {
  title: string;
  entries: ExerciseCompletionEntry[];
  isInitiallyOpen: boolean;
}

export function RecentExerciseSessions({
  title,
  entries,
  isInitiallyOpen,
}: RecentExerciseSessionsProps) {
  if (entries.length === 0) {
    return null;
  }
  return (
    <details className="mt-1.5" open={isInitiallyOpen}>
      <summary className="text-[11px] font-semibold text-zooprimary cursor-pointer">{title}</summary>
      <ul className="mt-1 space-y-0.5">
        {entries.map(function renderEntry(entry) {
          return (
            <li key={entry.completedOn} className="text-[11px] text-zoomuted">
              <span className="font-semibold text-zooindigo">
                {formatIsoDateToDayAndMonth(entry.completedOn)}
              </span>
              {entry.note === null ? null : ' — ' + entry.note}
            </li>
          );
        })}
      </ul>
    </details>
  );
}
